import { useAtom } from "jotai";
import React, { useState } from "react";
import "~/css/ProblemOccurs.css";
import { PlaySound } from "~/SoundUtils";
import ConfirmationModal from "./ConfirmationModal";
import { volumeAtom } from "~/Atom";
import { useTranslation } from "react-i18next";

/**
 * 不具合発生修復手順モーダルのコンポーネント
 */
const ProblemOccurs: React.FC = () => {
  const [volume] = useAtom(volumeAtom);
  const [isReloadModalOpen, setIsReloadModalOpen] = useState(false);
  const { t } = useTranslation();

  /**
   * モーダル操作の共通処理 - オープン
   * サウンドを再生してモーダルを開く
   */
  const handleModalOpen = (setModalState: React.Dispatch<React.SetStateAction<boolean>>) => {
    PlaySound("push", volume);
    setModalState(true);
  };

  /**
   * モーダル操作の共通処理 - クローズ
   * サウンドを再生してモーダルを閉じ、音声認識を再起動する
   */
  const handleModalClose = (setModalState: React.Dispatch<React.SetStateAction<boolean>>) => {
    PlaySound("push", volume);
    setModalState(false);
  };

  /**
   * ページをリロードする
   */
  const reload = () => {
    window.location.reload();
  };

  return (
    <>
      <ConfirmationModal
        show={isReloadModalOpen}
        handleClose={() => handleModalClose(setIsReloadModalOpen)}
        handleConfirm={reload}
        title={t("reloadTitle")}
        body={t("reloadBody")}
        cancelText={t("reloadCancelText")}
        confirmText={t("reloadConfirmText")}
      />
      <div className="problem-container">
        <h2>{t("problemOccursMessage")}</h2>
      </div>
      <div className="problem-container">
        <div className="problem-title-container">
          <h2>{t("problemOccursStep1")}</h2>
          <div className="problem-reload-button-container">
            <button
              className="btn btn-danger"
              onClick={() => handleModalOpen(setIsReloadModalOpen)}
            >
              {t("reload")}
            </button>
            <h5>{t("problemOccursReloadMessage")}</h5>
          </div>
        </div>
        <div className="problem-title-container">
          <h2>{t("problemOccursStep2")}</h2>
        </div>
        <div className="problem-title-container">
          <h2>{t("problemOccursStep3")}</h2>
        </div>
      </div>
    </>
  );
};

export default ProblemOccurs;
